import { AUTHORIZE, GET_FACTORS, RESEND_PASSCODE, SIGN_IN, SKIP_FACTORS, CHECK_OKTA_SESSION, GET_QUESTION_STATUS, AUTHORIZE_IN_OKTA, DELETE_OKTA_SESSION, CLEAN_UP, CHECK_ENCDATA_TOKEN, ENC_DATA_SIGN_IN } from './constants';

export function signIn(username, password, context, options,stateId) {
  return {
    type: SIGN_IN,
    data: {username: username, password: password,stateId: stateId, context:context, ...(options) && {options : options}}
  };
}

export function encDataSignIn(username, password) {
  return {
    type: ENC_DATA_SIGN_IN,
    data: {username: username, password: password}
  };
}

export function checkOktaSession() {
  return {
    type: CHECK_OKTA_SESSION
  };
}

export function decodeEncData(encData) {
  return {
    type: CHECK_ENCDATA_TOKEN,
    data: { "token" : encData }
  };
}

export function deleteOktaSession(idpFlow) {
  return {
    type: DELETE_OKTA_SESSION,
    data: idpFlow
  };
}

export function cleanUp(idpFlow) {
  return {
    type: CLEAN_UP,
    data: idpFlow
  };
}


export function authorizeInOktaDirectly() {
  return {
    type: AUTHORIZE_IN_OKTA
  };
}



export function getFactors(userGuid) {
  return {
    type: GET_FACTORS,
    data: {userGuid}
  };
}

export function getQuestionStatus(userGuid) {
  return {
    type: GET_QUESTION_STATUS,
    data: {userGuid}
  };
}

export function resendPasscode(userGuid, factorId, data) {
  return {
    type: RESEND_PASSCODE,
    data,
    userGuid,factorId
  };
}

export function authorize(oidcParams, user) {
  return {
    type: AUTHORIZE,
    data : {oidcParams,user}
  };
}

export function skipFactors() {
  return {
    type: SKIP_FACTORS
  };
}
